<div class="box">
  @if (isLoader) {
    <div class="d-flex justify-content-center">
      <app-loader size="small"></app-loader>
    </div>
  } @else {
    @if (dataSource$ | async; as dataSource) {
      <app-table
        class="w-100"
        [dataSource]="dataSource"
        [visibleColumnKeys]="visibleColumns"
        (onSortChange)="onSortChange($event)"
        (onPaginationChange)="onPaginationChange($event)"
      ></app-table>
    }
  }
</div>
